import React, { useRef } from 'react';
import { ModuleBase, ResponsiveImage } from '@/components';
import { ImageModel, ModuleBaseModel, ModuleSectionPropsModel } from '@/types';
import Flicking from '@egjs/react-flicking';
import { AutoPlay } from '@egjs/flicking-plugins';
import { useTranslations } from 'next-intl';

type LogoCarouselModel = ModuleBaseModel<
  {
    images?: ImageModel[];
  } & ModuleSectionPropsModel
>;

const LogoCarousel = (data: LogoCarouselModel) => {
  const { images } = data.props;
  const t = useTranslations();

  const carousel = useRef<Flicking>(null);

  const plugins = [
    new AutoPlay({
      animationDuration: 3000,
      delayAfterHover: 500,
      duration: 0,
      direction: 'NEXT',
      stopOnHover: true,
    }),
  ];

  if (!images) return null;

  const carouselImages: ImageModel[] = [];
  for (let i = 0; i <= 7; i++) {
    carouselImages.push(...images);
  }

  return (
    <ModuleBase data={data} noPadding>
      <div className="py-4 md:py-[40px] xl:py-[calc(40*100vh/911)]">
        <div onMouseEnter={() => carousel.current?.stopAnimation()}>
          <Flicking
            ref={carousel}
            plugins={plugins}
            align="prev"
            circular
            preventDefaultOnDrag
            resizeOnContentsReady={false}
            easing={(x) => x}
            moveType="freeScroll"
            interruptable
          >
            {carouselImages.map((image, index) => (
              <div
                key={index}
                className="mx-10 h-14 w-[calc(170*100vh/911)] sm:w-[170px] md:mx-16 md:h-16 md:w-[216px]"
              >
                <ResponsiveImage image={image} imgProps={{ className: '!object-contain' }} heights={{ xs: 200 }} />
              </div>
            ))}
          </Flicking>
        </div>
      </div>
    </ModuleBase>
  );
};

export default LogoCarousel;
